import { DataTableEmptyCell } from "@bcc/components/data-table";
import { ShipToFlagIconDisplay } from "@bcc/components/products/products-table/cells/ShipToFlagIconDisplay";
import type { PurchaseOrder } from "@shared/types";
import type { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { getShipToFlagCountryCode, setOrderShipToFlagsCellTestId, setOrderShipToFlagsFlagTestId } from "./order-ship-to-flags-cell.utils";

export const OrderShipToFlagsCell = (props: CellContext<PurchaseOrder, unknown>) => {
  const { t } = useTranslation();
  const address = props.row.original.shippingAddress;
  const countryCode = getShipToFlagCountryCode(address);
  const countryLabel = address?.country ?? address?.countryCode;

  if (!countryCode) return <DataTableEmptyCell />;

  return (
    <ShipToFlagIconDisplay
      countryCodes={[countryCode]}
      ariaLabel={t("views.orders.columns.shipToFlagsAriaLabel", { country: countryLabel })}
      testId={setOrderShipToFlagsCellTestId(props.row.index)}
      getFlagTestId={(code) => setOrderShipToFlagsFlagTestId(props.row.index, code)}
    />
  );
};
